import type { InputHTMLAttributes } from 'react'

interface NumberInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'value' | 'onChange'> {
  /** Kept as text so the field can be emptied while typing; callers validate on submit. */
  value: string
  onChange: (value: string) => void
  fullWidth?: boolean
}

/** Native number input in the kit's text-input style, as the other forms of the cockpit do. */
export function NumberInput({ value, onChange, fullWidth = true, className, ...rest }: NumberInputProps) {
  return (
    <input
      type="number"
      inputMode="numeric"
      step={1}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`htl-text-input ${fullWidth ? 'htl-text-input--full-width' : ''} ${className ?? ''}`}
      {...rest}
    />
  )
}
